import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202408/new-term-2024/Index.vue')
const NewTermGymnastics = () => import('../activity/202409/new-term-gymnastics/Index.vue')
const Tice202411 = () => import('../activity/202411/tice/Index.vue')

export const tice201411Route: RouteConfig = {
  path: '/202411-tice',
  name: '202411_tice',
  component: Tice202411,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024体测强化',
    ignoreLogin: true,
  },
}

export const indexRoute: RouteConfig = {
  path: '/new-term-2024',
  name: 'new_term_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024新学期体育作业方案',
    ignoreLogin: true,
  },
}

export const newTermGymnasticsRoute: RouteConfig = {
  path: '/new-term-gymnastics-2024',
  name: 'new_term_gymnastics_2024',
  component: NewTermGymnastics,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024新学期广播操方案',
    ignoreLogin: true,
  },
}

export default [indexRoute, newTermGymnasticsRoute, tice201411Route]
